import React from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import Rating from '@mui/material/Rating';
import MenuItem from '@mui/material/MenuItem';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import {
  API_URL_COMPANY,
  API_URL_RATING,
} from '../../configuration/Configuration';
import { menuItemsDict } from '../../configuration/Utils';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CustomerData = (props) => {
  const { key } = useLocation();
  const [company, setComp] = React.useState('');
  const [ratings, setRatings] = React.useState('');
  const [options, setOptions] = React.useState({});
  const [customersById, setCustomersById] = React.useState({});
  const [selectedEmails, setSelectedEmails] = React.useState([]);
  const [pendingInput, setPendingInput] = React.useState('');

  const [valueRating, setRatingValue] = React.useState(2);

  useEffect(() => {
    setComp('');
    setSelectedEmails([]);
    setPendingInput('');
    getCompanies();
  }, [key]);

  useEffect(() => {
    if (!props.customer || props.customer === 'N/A') {
      return;
    }

    setComp(props.customer);
    setSelectedEmails(props.selectedCustomerEmails || []);
  }, [props.customer, props.selectedCustomerEmails, customersById]);

  const updateParentSelection = (customerName, emails) => {
    const currentCustomer = customersById[customerName];
    props.func({
      name: customerName,
      selectedEmails: emails,
      availableEmails: currentCustomer?.email_addresses || [],
    });
  };

  // handle selection of company
  const changeCompany = (event) => {
    const nextCompany = event.target.value;
    const currentCustomer = customersById[nextCompany];
    const nextSelectedEmails = currentCustomer?.email_addresses || [];

    setComp(nextCompany);
    setSelectedEmails(nextSelectedEmails);
    setPendingInput('');
    updateParentSelection(nextCompany, nextSelectedEmails);
  };

  const handleNext = () => {
    const trimmed = pendingInput.trim();
    if (trimmed) {
      const newEmails = [...selectedEmails, trimmed];
      setSelectedEmails(newEmails);
      setPendingInput('');
      updateParentSelection(company, newEmails);
    }
    props.handleNext();
  };

  const getCompanies = () => {
    (async () => {
      const opt = {};
      const ratings = {};
      const customerMap = {};
      const { data } = await axios.get(API_URL_COMPANY);

      // Sort the data alphabetically by name before processing
      data.sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      );

      data.forEach((value) => {
        opt[value.pk] = value.name;
        customerMap[value.pk] = value;
        if (value.rating !== null) {
          ratings[value.name] = value.rating;
        }
      });
      setOptions(opt);
      setCustomersById(customerMap);
      setRatings(ratings);
    })();
  };

  const postRating = async () => {
    const tenderData = new FormData();
    // Update the formData object
    tenderData.append('rating', valueRating);
    tenderData.append('name', company);
    await axios
      .post(API_URL_RATING, tenderData)
      .then((res) => console.log('Rating posted', res.data));
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container xs={12} sx={{ mt: 5 }}>
        <Typography align="left" sx={{ mt: 0, mb: 1, width: '100%' }}>
          <strong>Select the customer</strong>
        </Typography>
        {/* <Typography sx={{ mt: 2, mb: 1 }}>Company</Typography> */}

        <Select
          value={company}
          label=""
          align="left"
          sx={{ width: '350px', mr: 2 }}
          onChange={changeCompany}
        >
          {menuItemsDict(options)}
        </Select>
      </Grid>
      <Grid container xs={12} sx={{ mt: 3 }}>
        <Typography align="left" sx={{ mt: 0, mb: 1, width: '100%' }}>
          <strong>Customer Account Manager</strong>
        </Typography>
        <Autocomplete
          multiple
          freeSolo
          id="customer-email-select"
          disabled={!company}
          options={customersById[company]?.email_addresses || []}
          value={selectedEmails}
          inputValue={pendingInput}
          onInputChange={(event, newInputValue) => {
            setPendingInput(newInputValue);
          }}
          onChange={(event, newValue) => {
            setSelectedEmails(newValue);
            setPendingInput('');
            updateParentSelection(company, newValue);
          }}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip variant="outlined" label={option} {...getTagProps({ index })} size="small" />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Customer Account Manager"
              placeholder={selectedEmails.length === 0 ? 'Select or type an email, then press Enter' : ''}
            />
          )}
          sx={{ width: '350px' }}
        />
        <Typography
          variant="caption"
          display="block"
          align="left"
          sx={{ mt: 1, mb: 1, width: '100%' }}
        >
          {!company
            ? 'Choose a customer first.'
            : (customersById[company]?.email_addresses || []).length === 0
              ? 'This customer has no saved email addresses yet. Contacts can be added after the tender is created.'
              : 'Selected emails will be included as reference contacts in the new tender notification.'}
        </Typography>
      </Grid>
      <Grid align="left" sx={{ mt: 3, mb: 5 }}>
        <Button
          onClick={handleNext}
          variant="contained"
          size="medium"
          disabled={!company}
        >
          Next
        </Button>
      </Grid>

      <Grid>
        <Typography align="left" sx={{ mt: 2, mb: 1 }}>
          <strong>Customer rating.</strong>
          <br />{' '}
          <span style={{ fontSize: '12px' }}>
            (e.g. based on latest experience in paymnet reliability, complaint
            management)
          </span>
        </Typography>
        {/* </Grid> */}
        {/* <Grid item xs={2}> */}
        {/* <Typography sx={{ mt: 2, mb: 1 }}>Customer Rating</Typography> */}
        <Grid xs={3} alignItems="center" container>
          <Rating
            name="controlled"
            size="large"
            defaultValue={5}
            value={valueRating}
            onChange={(event, newValue) => {
              setRatingValue(newValue);
            }}
          />
          <Button
            sx={{ ml: 2 }}
            variant="outlined"
            size="small"
            onClick={postRating}
            color="inherit"
          >
            Update Rating
          </Button>
        </Grid>

        <Grid item xs={2}></Grid>
      </Grid>
    </Box>
  );
};
export default CustomerData;
